var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuobiGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#2483ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.57 397.57c0-73.51-35.83-136.73-63.08-157.32-.11-.06-2.09-1.17-1.92 1.77v.09c-2.26 141.94-74.81 180.41-114.69 232.23-92 119.59-6.44 250.71 80.72 274.94 48.77 13.56-11.26-24-19-103.31-9.35-95.87 118-169 118-248.4m41.82 48.33c-.56-.38-1.35-.64-1.9.27-1.5 17.87-19.76 56.09-42.9 91.18-78.5 119-33.76 176.43-8.61 207.25 14.61 17.89 0 0 36.51-18.29 2.86-1.43 71.23-39.76 78.63-127.08 7.17-84.56-43.64-137.85-61.72-153.34",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobiGlobal);
export default __webpack_public_path__ + "static/media/HuobiGlobal.3f6411ea2bc0d601653da7c8d3044d54.svg";
export { ForwardRef as ReactComponent };